import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async buscarEntradasBloqueadasDashboard(api, parametros) {
    parametros.operacao = 'buscarEntradasBloqueadasDashboard';

    let retorno = {};

    await api.santriGET('/rest/entrada', parametros, 15, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  }
}


// WEBPACK FOOTER //
// ./src/components/Rest/REntrada/REntradaBuscarEntradasBloqueadasDashboard.js